import React from 'react';

import { ListItem, ListItemText, Stack, Typography } from '@gogame/components';

const MenuItem = ({ label, count, total, selected, disabled, onClick }) => {
  return (
    <ListItem
      button={true}
      selected={selected}
      disabled={disabled}
      onClick={onClick}
      divider={true}
      style={{ height: 48 }}
    >
      <ListItemText
        primary={
          <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Typography color={'inherit'}>{label}</Typography>
            <Typography>{`${count} / ${total}`}</Typography>
          </Stack>
        }
      />
    </ListItem>
  );
};

export default MenuItem;
